module.exports = __webpack_public_path__ + "static/crafter-465f966951cfdd2218bddd5770fbf380.png";